<template>
  <div class="search-box">
    <div class="search-box__content">
      <van-search 
        v-model.trim="value"
        shape="round"
        v-bind="$attrs"
        @search="handleSearch"
      ></van-search>
      <div class="search-btn-box">
        <van-button type="warning" class="search-btn" @click="handleSearch">搜索</van-button>
      </div>
    </div>
  </div>

</template>

<script>
import { Search , Button } from "vant";
export default {
  components: {
    [Search.name]: Search,
    [Button.name]: Button,
  },
  data(){
    return {
      value: ""
    }
  },
  methods: {
    handleSearch(){
      this.$emit("search",this.value);
    }
  }
};
</script>

<style scoped lang="scss">
  .search-box {
    display: flex;
    align-items: center;
    background: linear-gradient( 177deg, #FFBD2D 0%, #EC892E 100%);
    padding: 1px;
    border-radius: 20px;
    height: 36px;
    flex: 1;
    overflow: hidden;
    .search-box__content {
      height: 100%;
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
      background-color: #FFF;
      border-radius: 20px;
    }
    .search-btn-box {
      height: calc(100% - 2px);
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      padding: 0 1px;
      .search-btn {
        flex: 1;
        height: 100%;
        background: linear-gradient( 172deg, #FFBD2D 0%, #EC892E 100%);
        flex-shrink: 0;
        width: 77px;
        border-radius: 20px;
        font-size: 14px;
        line-height: 14px;
        color: #FFF;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }
    }
  }
  ::v-deep.van-search {
    flex: 1;
    overflow: hidden;
    padding: 0 !important;
    .van-search__content {
      background: transparent !important;
      .van-cell {
        border-radius: 20px;
      }
      .van-field__control {
        font-size: 14px;
        color: #3D3833;
        &::placeholder {
          font-size: 14px;
          color: #C9C2BB;
        }
      }
    }
  }
</style>
